<template>
    <div class="space-y-3">
        <h2 class="font-semibold text-lg">{{ t('statistics.title') }}</h2>

        <table class="w-full bg-surface-card rounded overflow-hidden">
            <thead>
                <tr class="border-b border-white/10">
                    <td class="text-left p-2">{{ t('statistics.zone') }}</td>
                    <td class="p-2 text-center">
                        <a class="bg-white/10 px-2 py-0.5 rounded mr-2" href="#" @click.prevent="dayLeft">◀</a>
                        <template v-if="isToday">{{ t('statistics.today') }}</template>
                        <template v-else>{{ formattedDay }}</template>
                        <a class="bg-white/10 px-2 py-0.5 rounded ml-2" href="#" @click.prevent="dayRight">▶</a>
                    </td>
                    <td class="p-2 text-center">{{ t('statistics.total') }}</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="zone in events.zoneStats" :key="zone.name" class="border-t border-white/5">
                    <td class="p-2">{{ zone.name }}</td>
                    <td class="p-2 text-center">{{ zone.today }}</td>
                    <td class="p-2 text-center">{{ zone.total }}</td>
                </tr>
            </tbody>
        </table>

        <AppButton variant="success" block @click="refreshStats">{{ t('statistics.refresh') }}</AppButton>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue'
    import { useEventsStore } from '@/stores/events'
    import { useI18n } from 'vue-i18n'
    import AppButton from '@/components/ui/AppButton.vue'

    const events = useEventsStore()
    const { t } = useI18n()

    const day = ref(new Date().toISOString().slice(0, 10))

    const isToday = computed(() => day.value === new Date().toISOString().slice(0, 10))
    const formattedDay = computed(() => {
        const d = new Date(day.value)
        return `${d.getDate()}.${d.getMonth() + 1}.`
    })

    async function refreshStats() {
        events.zoneStats.forEach(z => {
            z.today = '?'
            z.total = '?'
        })
        try {
            await events.loadZoneStats(day.value)
        } catch {
            // ignore
        }
    }

    function dayLeft() {
        day.value = new Date(new Date(day.value).getTime() - 86_400_000).toISOString().slice(0, 10)
        void refreshStats()
    }

    function dayRight() {
        day.value = new Date(new Date(day.value).getTime() + 86_400_000).toISOString().slice(0, 10)
        void refreshStats()
    }

    onMounted(() => {
        void events.loadZoneStats(day.value).catch(() => undefined)
    })
</script>
